import React, { Component } from 'react';

import { connect } from 'react-redux';
import FormField from '../../style/styledComponents/FormField';
import FormButton from '../../style/styledComponents/FormButton';
import BoxSize from '../../style/styledComponents/BoxSize';
import Icons from '../../style/styledComponents/Icons';
import { bindActionCreators } from 'redux';
import { verifyTokenCmDrConsulta } from '../../_redux/actions/cmDrConsulta';

import Header from '../../Components/Header';

import NavBtn from '../../Components/NavBtn';
import LoadingB from '../../Components/LoadingBeneficiario';

import EpayGirl from '../../img/epayGirl.svg';
import { FiAlertCircle } from 'react-icons/fi';
import { FaExclamation } from 'react-icons/fa';

import { formUtils, campaignUtils } from '../../utils';
import { getPlanList } from '../../_redux/actions/plan';

//import './index.scss';

import stores from '../../utils/stores';

import { isEmptyArray } from 'formik';
import { ThemeProvider } from 'styled-components';
import ThemeSelector from '../../style/themes/ThemeSelector';
import { setWaitCampaign } from '../../_redux/actions/campaign';
class HomeCmDrConsulta extends Component {
	constructor(props) {
		super(props);

		this.state = {
			inputData: {
				psw: '',
				loja: 'cmdrconsulta'
			},
			hasError: false,
			isComplete: false,
			errorOnField: {},
			title: '',
			error: '',
			loading: false
		};

		this.setField = this.setField.bind(this);
		this.validateField = this.validateField.bind(this);
		this.clearErrorOnFocus = this.clearErrorOnFocus.bind(this);
		this.handleIsComplete = this.handleIsComplete.bind(this);
		this.sendCode = this.sendCode.bind(this);
		this.clearError = this.clearError.bind(this);
		this.isComplete = this.isComplete.bind(this);
	}

	componentDidMount() {
		sessionStorage.setItem('store', stores.cmDrConsulta);
		const loja = 'cmdrconsulta';
		this.props.getPlanList(loja);
	}

	setField(e) {
		let value = e.target.value;
		let psw = e.target.getAttribute('psw');

		if (psw === 'psw') {
			value = value.replace(/( )+/g, '');
		}
		let inputData = { ...this.state.inputData };
		inputData['psw'] = value;
		this.setState({
			inputData
		});

		this.handleIsComplete(e, 'psw');
	}

	clearErrorOnFocus(field) {
		this.setState({
			errorOnField: {
				...this.state.errorOnField,
				[field]: null
			}
		});
	}

	removeWhiteSpace(field, e) {
		this.validateField(e, 'psw');
		let value = field.trim();

		let inputData = { ...this.state.inputData };

		inputData['psw'] = value;
		this.setState({
			inputData
		});

		this.handleIsComplete();
	}

	validateField(e, field) {
		const errorMsgs = {
			psw: 'Código inválido'
		};

		const isValid = this.checkField(field, e.target.value);
		if (isValid) {
			this.setState({
				errorOnField: { ...this.state.errorOnField, [field]: null },
				isComplete: true
			});
		} else {
			this.setState({
				errorOnField: {
					...this.state.errorOnField,
					[field]: errorMsgs[field]
				}
			});
		}

		this.handleIsComplete(e, 'psw');
	}

	handleIsComplete(e, field) {
		const isIncomplete = this.checkField(field, e.target.value);

		if (isIncomplete) {
			this.setState({
				isComplete: true
			});
		} else {
			this.setState({
				isComplete: false
			});
		}
	}

	checkField(field, value) {
		let isValidField = false;
		let checkField = {
			psw: /^[a-z0-9]{11}$/g
		};

		if (checkField[field].test(value)) {
			isValidField = true;
		} else isValidField = false;

		return isValidField;
	}

	sendCode() {
		let Plan = this.props.Plan.list;
		const signatureTypeAndPlanId = campaignUtils.getSignatureTypeAndPlanId(
			this.props.location.search
		);
		const loja = 'cmdrconsulta';
		const psw = this.state.inputData.psw;

		this.setState({
			loading: true
		});

		let signaturePlan = '';

		signaturePlan = Plan.filter(
			plan =>
				plan.signature_type === signatureTypeAndPlanId.assinatura &&
				plan.planId === signatureTypeAndPlanId.code
		);

		if (isEmptyArray(signaturePlan)) {
			this.setState({
				hasError: true,
				loading: false,
				title: 'Ops!',
				error: 'Assinatura invalida, escolha a assinatura novamente.'
			});

			if (this.state.hasError === false) {
				return (window.location = 'https://yalo.com.br/cmdrconsulta/');
			}
		}

		var result = this.props.verifyTokenCmDrConsulta(signaturePlan, psw);
		result.then(hasError => {
			if (!hasError) {
				this.setState({
					loading: false
				});
				let signatureType = this.props.CmDrConsulta.data.signature_type;
				this.props.history.push(
					process.env.PUBLIC_URL +
						`/${loja}/beneficiario?assinatura=${signatureType}`
				);

				if (campaignUtils.checkExistInStorage(this.props.location.search)) {
					let campaignData = campaignUtils.getData();

					sessionStorage.setItem('utmTerm', campaignData.utmTerm);
					sessionStorage.setItem('utmMedium', campaignData.utmMedium);
					sessionStorage.setItem('utmSource', campaignData.utmSource);
					sessionStorage.setItem('utmCampaign', campaignData.utmCampaign);

					this.props.setWaitCampaign(campaignData);
				}
			} else {
				this.setState({
					hasError: true,
					loading: false,
					title: 'Ops!',
					error: 'O token digitado é inválido. Por favor, tente novamente.'
				});
			}
		});
	}

	clearError() {
		this.setState({
			hasError: null
		});
	}

	isComplete() {
		if (this.state.inputData.psw?.length < 11) {
			this.setState({
				errorOnField: {
					...this.state.errorOnField,
					psw: 'Token inválido'
				}
			});
		}
	}

	render() {
		let errorElm = null;

		if (this.state.hasError) {
			errorElm = (
				<div className='overlay'>
					<FormButton className='overlay-box'>
						<BoxSize className='overlay-box--content-epay'>
							<div className='title-alert2'>
								<Icons className='icon-container2'>
									<FaExclamation color={'white'} size={16} />
								</Icons>
								<h2>{this.state.title}</h2>
							</div>
							<p>{this.state.error} </p>
						</BoxSize>
						<div className='overlay-button'>
							<button
								className='overlay-box--close f-bold btn-border-color-ok-epay'
								onClick={this.clearError}>
								TENTAR NOVAMENTE
							</button>
						</div>
					</FormButton>
				</div>
			);
		}
		const pathArray = window.location.pathname.split('/');
		return (
			<ThemeProvider theme={ThemeSelector(pathArray[2])}>
				<div className='page-wrapper'>
					<div className='footer-adjustment'>
						{errorElm}
						<Header {...this.props} />
						<BoxSize className=''>
							<div className='content-cmd'>
								<h2>Bem-vindo à YALO vendas centro médico dr.consulta!</h2>
								<div className='visible-xs visible-sm'>
									<p>Informe seu código de acesso!</p>
								</div>
								<div className='row visible-md visible-lg'>
									<p>Informe seu código de acesso!</p>
								</div>
							</div>
						</BoxSize>
						<BoxSize className=''>
							<div className='box-content-group'>
								<img src={EpayGirl}></img>

								<FormField className=''>
									<div className='form-group2 form-container'>
										<input
											maxLength='11'
											type='password'
											className='form-control2'
											required
											id='psw'
											name='psw'
											onChange={e => this.setField(e)}
											onFocus={() => this.clearErrorOnFocus('psw')}
											onBlur={e => this.validateField(e, 'psw')}
											value={this.state.inputData.psw}
										/>
										<label htmlFor='psw'>Token de acesso</label>
										{this.state.errorOnField.psw && (
											<div className='error-msg'>
												<FiAlertCircle size={13} color={'red'} />
												<small className='credit-card-error'>
													{this.state.errorOnField.psw || 'Código inválido'}
												</small>
											</div>
										)}
									</div>
								</FormField>
								{!this.state.isComplete ? (
									<NavBtn
										disabled={!this.state.isComplete}
										goForward={this.isComplete}
										goForwardText={'CADASTRAR ASSINATURA'}
										step={true}></NavBtn>
								) : this.state.loading ? (
									<div className='loading-beneficiario2'>
										<LoadingB type='spin' color='gray' size={25} />
										<span>Carregando...</span>
									</div>
								) : (
									<NavBtn
										disabled={this.state.isLoading}
										goForward={this.sendCode}
										goForwardText={'CADASTRAR ASSINATURA'}></NavBtn>
								)}
							</div>
						</BoxSize>
					</div>
					<div className='container-fluid'></div>
				</div>
			</ThemeProvider>
		);
	}
}

const mapStateToProps = actionObject => {
	return actionObject;
};

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			getPlanList,
			verifyTokenCmDrConsulta,
			setWaitCampaign
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(HomeCmDrConsulta);
